import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UnvalidToast from "../../toasts/UnvalidToast";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { likerOrNotTrocTraveler } from "../../../services/callAPI/toTravelerTrocs";

interface IBtnIconeTrashProps {
  travTrocId: number;
  resTrocId?: number;
  isLikedByRes: boolean;
  triggerUseEffect: boolean;
  settriggerUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
}

function BtnLikerTroc(props: IBtnIconeTrashProps) {
  //destructuring
  const { travTrocId, isLikedByRes, settriggerUseEffect, triggerUseEffect } = props;

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  const [errorMsg, seterrorMsg] = useState<string | undefined>(undefined);

  async function handleLikeOrNotLikeTroc(trocTId: number) {
    try {
      //call API
      const status = await likerOrNotTrocTraveler(trocTId);

      if (status === 204) {
        settriggerUseEffect(!triggerUseEffect);
      }
      else {
        throw new Error("Une erreur est survenue.");
      }

    } catch (error) {
      if (error instanceof Error) {
        seterrorMsg(error.message);//add error msg

        //show UnvalidToast
        setIsShowUnvalidToast(true);
      }
      else {
        //show UnvalidToast
        setIsShowUnvalidToast(true);

        const timer = setTimeout(() => {
          settriggerUseEffect(!triggerUseEffect);
        }, 4000);

        //clean timer
        return () => clearTimeout(timer);
      }
    }
  }

  return (
    <>
      {isShowUnvalidToast && <UnvalidToast message={errorMsg} onClose={() => setIsShowUnvalidToast(false)} />}

      <button className="focus:outline-none focus:ring-transparent flex gap-1 items-center bg-orangeCustom text-white rounded-md p-1" onClick={() => handleLikeOrNotLikeTroc(travTrocId)}>
        <i className={`${isLikedByRes ? "text-greenCustom" : "text-white"} p-1`}>
          <FontAwesomeIcon className="w-7 h-auto" icon={faThumbsUp} />
        </i>
      </button>
    </>
  )
}
export default BtnLikerTroc;